import { Card, Image, Overlay, Text } from '@mantine/core';
import { Lock } from 'lucide-react';
import classes from './VideoCard.module.css';
import { useState } from 'react';

function VideoCard({ video, setSelectedVideo, image, title, style }: any) {
  const enabled = !video.id || video.has_product;
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Card
      key={`v-${video.id}`}
      className={classes.card}
      opacity={enabled ? 1 : 0.5}
      style={{
        flex: '0 0 350px',
        cursor: enabled && 'pointer',
        boxShadow:
          enabled && isHovered
            ? '0 4px 16px rgba(0,0,0,0.15)'
            : '0 4px 5px rgba(0,0,0,0.15)',
        ...style,
      }}
      bd={
        enabled && isHovered
          ? 'solid var(--mantine-color-blue-5)'
          : 'solid var(--mantine-color-gray-2)'
      }
      bg={enabled && isHovered ? 'var(--mantine-color-blue-0)' : 'white'}
      padding='lg'
      radius='sm'
      onClick={() => {
        if (enabled) {
          setSelectedVideo(video.url ? [video.url] : video);
        }
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Card.Section style={{ position: 'relative' }}>
        <Image
          src={image ?? video.image}
          alt={title ?? video.name ?? 'Video cover'}
          height={200}
        />
        {!enabled && (
          <>
            <Overlay color='#000' backgroundOpacity={0.7} zIndex={1} blur={5} />
            <Lock
              size={32}
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: '#fff',
                zIndex: 2,
              }}
            />
          </>
        )}
      </Card.Section>

      <Text fz='sm' fw={700} mt={'md'} ta='center'>
        {title ?? video.name}
      </Text>
    </Card>
  );
}

export default VideoCard;
